/* Zorian Batting Practice mini game */
(function () {
  function init() {
    var cv = document.getElementById('zaCanvas');
    if (!cv || cv.dataset.ready) return;
    cv.dataset.ready = '1';
    var ctx = cv.getContext('2d');
    var W = 960, H = 440;
    var dpr = Math.min(window.devicePixelRatio || 1, 2);
    cv.width = W * dpr; cv.height = H * dpr;
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);

    var el = function (id) { return document.getElementById(id); };
    var btn = el('zaSwing');
    var ui = { pitch: el('zaPitch'), score: el('zaScore'), hr: el('zaHR'), best: el('zaBest') };

    var PITCHES = 10;
    var P = { x: 222, y: 252 };
    var BAT_LEN = 150;
    var CONTACT_X = P.x + 100;
    var REL = { x: 792, y: 212 };
    var CATCH_X = 120;
    var A0 = -2.5, A1 = 0.95, OMEGA = 0.0092;
    var FWD_MS = (A1 - A0) / OMEGA, WRAP_MS = 260, WRAP_TO = -1.5;

    var best = 0;
    try { best = parseInt(localStorage.getItem('zorianBestScore') || '0', 10) || 0; } catch (e) {}

    var g = {
      state: 'idle', pitchNo: 0, score: 0, hr: 0,
      windupStart: 0, windupMs: 0, release: 0, T: 0, ballYEnd: 252,
      swingStart: null, judged: false, result: null, resultAt: 0,
      ball: null, hit: null, particles: [], trail: [], flash: 0
    };

    function hud() {
      ui.pitch.textContent = g.pitchNo + '/' + PITCHES;
      ui.score.textContent = g.score;
      ui.hr.textContent = g.hr;
      ui.best.textContent = best;
      btn.textContent = (g.state === 'idle' || g.state === 'over') ? (g.state === 'over' ? 'Play Again' : 'Play Ball') : 'Swing!';
    }

    function startRound(now) {
      g.pitchNo = 0; g.score = 0; g.hr = 0;
      nextPitch(now);
    }

    function nextPitch(now) {
      if (g.pitchNo >= PITCHES) { endRound(); return; }
      g.pitchNo++;
      g.state = 'windup';
      g.windupStart = now;
      g.windupMs = 700 + Math.random() * 900;
      var speed = Math.random();
      g.T = speed < 0.2 ? 820 + Math.random() * 180 : 520 + Math.random() * 230;
      g.ballYEnd = P.y + (Math.random() * 16 - 8);
      g.swingStart = null; g.judged = false; g.result = null;
      g.ball = null; g.hit = null; g.trail = [];
      hud();
    }

    function endRound() {
      g.state = 'over';
      if (g.score > best) {
        best = g.score;
        try { localStorage.setItem('zorianBestScore', String(best)); } catch (e) {}
      }
      g.result = { big: 'Round Over', sub: g.score + ' pts  •  ' + g.hr + ' HR  •  tap to play again', color: '#ffffff' };
      hud();
    }

    function swing(now) {
      if (g.state === 'idle' || g.state === 'over') { startRound(now); return; }
      if (g.swingStart !== null) return;
      if (g.state !== 'windup' && g.state !== 'pitch') return;
      g.swingStart = now;
    }

    function batAngle(now) {
      if (g.swingStart === null) return A0;
      var t = now - g.swingStart;
      if (t <= FWD_MS) return A0 + OMEGA * t;
      var k = Math.min(1, (t - FWD_MS) / WRAP_MS);
      return A1 + (WRAP_TO - A1) * (1 - Math.pow(1 - k, 2));
    }

    function setResult(big, sub, color, now) {
      g.result = { big: big, sub: sub, color: color };
      g.resultAt = now;
      g.state = 'result';
      hud();
    }

    function judge(now) {
      g.judged = true;
      var tc = g.release + g.T;
      if (g.swingStart === null || g.swingStart > tc) {
        return;
      }
      var a = A0 + OMEGA * (tc - g.swingStart);
      var abs = Math.abs(a);
      var early = a > 0;
      if (abs < 0.45) {
        var type, pts, vx, vy;
        if (abs < 0.16) { type = 'HOME RUN!'; pts = 4; vx = 1.05; vy = -0.78; g.hr++; burst(CONTACT_X, g.ballYEnd); g.flash = 1; }
        else if (abs < 0.3) { type = 'DOUBLE!'; pts = 2; vx = 0.95; vy = -0.42; }
        else { type = 'SINGLE'; pts = 1; vx = 0.8; vy = -0.16; }
        g.score += pts;
        g.hit = { x: CONTACT_X, y: g.ballYEnd, vx: vx, vy: vy, t: now, ground: type === 'SINGLE' };
        var timing = abs < 0.16 ? 'Perfect timing' : (early ? 'A touch early' : 'A touch late');
        setResult(type, '+' + pts + (pts === 1 ? ' pt' : ' pts') + '  •  ' + timing, abs < 0.16 ? '#2e9bd6' : '#ffffff', now);
      } else if (abs < 0.7) {
        g.hit = { x: CONTACT_X, y: g.ballYEnd, vx: early ? -0.35 : 0.2, vy: -0.85, t: now, foul: true };
        setResult('FOUL BALL', early ? 'Just a little early' : 'Just a little late', '#cfe8f7', now);
      } else {
        setResult('STRIKE', early ? 'Way out in front. Wait on it!' : 'Too late. Start your swing sooner!', '#ff6b6b', now);
      }
    }

    function burst(x, y) {
      for (var i = 0; i < 40; i++) {
        var ang = Math.random() * Math.PI * 2, sp = 0.08 + Math.random() * 0.35;
        g.particles.push({ x: x, y: y, vx: Math.cos(ang) * sp, vy: Math.sin(ang) * sp, life: 900 + Math.random() * 500, born: performance.now(), c: Math.random() < 0.5 ? '#2e9bd6' : '#ffffff' });
      }
    }

    function bg() {
      var sky = ctx.createLinearGradient(0, 0, 0, 200);
      sky.addColorStop(0, '#081428'); sky.addColorStop(1, '#1b3768');
      ctx.fillStyle = sky; ctx.fillRect(0, 0, W, 200);
      [[90, 40], [870, 40]].forEach(function (t) {
        var gl = ctx.createRadialGradient(t[0], t[1], 2, t[0], t[1], 120);
        gl.addColorStop(0, 'rgba(255,255,255,.55)'); gl.addColorStop(1, 'rgba(255,255,255,0)');
        ctx.fillStyle = gl; ctx.fillRect(t[0] - 120, t[1] - 120, 240, 240);
        ctx.fillStyle = '#e9f4ff'; ctx.fillRect(t[0] - 22, t[1] - 8, 44, 14);
        ctx.fillStyle = '#0a1830'; ctx.fillRect(t[0] - 2, t[1] + 6, 4, 130);
      });
      ctx.fillStyle = '#0a1830'; ctx.fillRect(0, 120, W, 60);
      for (var i = 0; i < 260; i++) {
        var cx = (i * 37) % W, cy = 126 + ((i * 53) % 48);
        ctx.fillStyle = i % 5 === 0 ? 'rgba(46,155,214,.55)' : 'rgba(255,255,255,.12)';
        ctx.fillRect(cx, cy, 3, 3);
      }
      ctx.fillStyle = '#0d1f3c'; ctx.fillRect(0, 176, W, 30);
      ctx.fillStyle = '#2e9bd6'; ctx.fillRect(0, 176, W, 3);
      ctx.font = '600 15px Oswald, Arial, sans-serif';
      ctx.fillStyle = 'rgba(255,255,255,.9)'; ctx.textAlign = 'center';
      ctx.fillText('Z O R I A N   •   A M E R I C A ’ S   B A S E B A L L   B R A N D', W / 2, 197);
      ctx.fillStyle = 'rgba(255,255,255,.6)'; ctx.font = '600 13px Oswald, Arial, sans-serif';
      ctx.fillText('400', 120, 197); ctx.fillText('400', 840, 197);
      var gr = ctx.createLinearGradient(0, 206, 0, H);
      gr.addColorStop(0, '#1f6b3a'); gr.addColorStop(1, '#14522b');
      ctx.fillStyle = gr; ctx.fillRect(0, 206, W, H - 206);
      for (var s = 0; s < 12; s++) {
        if (s % 2) { ctx.fillStyle = 'rgba(255,255,255,.035)'; ctx.fillRect(s * 80, 206, 80, H - 206); }
      }
      ctx.fillStyle = '#b8875a';
      ctx.beginPath(); ctx.ellipse(280, 352, 190, 58, 0, 0, Math.PI * 2); ctx.fill();
      ctx.beginPath(); ctx.ellipse(800, 318, 110, 26, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#a7784e';
      ctx.beginPath(); ctx.ellipse(800, 312, 40, 9, 0, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#fff';
      ctx.beginPath(); ctx.moveTo(300, 346); ctx.lineTo(336, 346); ctx.lineTo(344, 352); ctx.lineTo(318, 360); ctx.lineTo(292, 352); ctx.closePath(); ctx.fill();
      ctx.strokeStyle = 'rgba(255,255,255,.55)'; ctx.lineWidth = 2;
      ctx.strokeRect(160, 330, 110, 40);
      ctx.setLineDash([5, 6]); ctx.strokeStyle = 'rgba(207,232,247,.22)';
      ctx.strokeRect(CONTACT_X - 16, P.y - 32, 32, 64); ctx.setLineDash([]);
    }

    function pitcher(now) {
      var x = 800, y = 306;
      var prog = 0;
      if (g.state === 'windup') prog = Math.min(1, (now - g.windupStart) / g.windupMs);
      else if (g.state === 'pitch' || g.state === 'result') prog = 1;
      ctx.fillStyle = '#e8edf5'; ctx.strokeStyle = '#e8edf5'; ctx.lineCap = 'round';
      ctx.lineWidth = 9;
      var kick = g.state === 'windup' ? Math.sin(prog * Math.PI) * 26 : 0;
      ctx.beginPath(); ctx.moveTo(x, y - 52); ctx.lineTo(x + 10, y); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(x, y - 52); ctx.lineTo(x - 14 + kick * 0.4, y - kick); ctx.stroke();
      ctx.lineWidth = 16; ctx.beginPath(); ctx.moveTo(x, y - 54); ctx.lineTo(x + 2, y - 96); ctx.stroke();
      ctx.beginPath(); ctx.arc(x + 2, y - 110, 11, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#2e9bd6'; ctx.beginPath(); ctx.arc(x + 2, y - 113, 11, Math.PI, 0); ctx.fill();
      ctx.fillRect(x - 16, y - 115, 10, 4);
      var armA = g.state === 'windup' ? (-0.6 + prog * 3.4) : (g.state === 'idle' || g.state === 'over' ? 1.9 : 3.6);
      ctx.strokeStyle = '#e8edf5'; ctx.lineWidth = 7;
      var sx = x + 2, sy = y - 92;
      ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx + Math.cos(armA) * 30, sy + Math.sin(armA) * 30); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(sx, sy); ctx.lineTo(sx - 22, sy + 14); ctx.stroke();
      ctx.fillStyle = '#7a4a24'; ctx.beginPath(); ctx.arc(sx - 24, sy + 16, 7, 0, Math.PI * 2); ctx.fill();
    }

    function catcher() {
      var x = 120, y = 352;
      ctx.fillStyle = '#c9d3e1'; ctx.strokeStyle = '#c9d3e1'; ctx.lineCap = 'round'; ctx.lineWidth = 12;
      ctx.beginPath(); ctx.moveTo(x, y - 40); ctx.lineTo(x + 18, y - 18); ctx.lineTo(x + 6, y); ctx.stroke();
      ctx.lineWidth = 18; ctx.beginPath(); ctx.moveTo(x, y - 40); ctx.lineTo(x + 6, y - 70); ctx.stroke();
      ctx.beginPath(); ctx.arc(x + 10, y - 84, 11, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#0d1f3c'; ctx.fillRect(x + 12, y - 92, 9, 16);
      ctx.fillStyle = '#7a4a24'; ctx.beginPath(); ctx.arc(x + 30, y - 58, 10, 0, Math.PI * 2); ctx.fill();
    }

    function batter(now) {
      var hipX = 205, hipY = 292, footY = 344;
      ctx.lineCap = 'round'; ctx.strokeStyle = '#f2f5fa'; ctx.fillStyle = '#f2f5fa';
      ctx.lineWidth = 11;
      ctx.beginPath(); ctx.moveTo(hipX, hipY); ctx.lineTo(180, footY); ctx.stroke();
      ctx.beginPath(); ctx.moveTo(hipX, hipY); ctx.lineTo(236, footY); ctx.stroke();
      ctx.fillStyle = '#0d1f3c'; ctx.fillRect(170, footY - 4, 20, 8); ctx.fillRect(228, footY - 4, 20, 8);
      ctx.strokeStyle = '#1b3768'; ctx.lineWidth = 22;
      ctx.beginPath(); ctx.moveTo(hipX, hipY); ctx.lineTo(200, 242); ctx.stroke();
      ctx.strokeStyle = '#2e9bd6'; ctx.lineWidth = 3;
      ctx.beginPath(); ctx.moveTo(210, 286); ctx.lineTo(206, 246); ctx.stroke();
      ctx.fillStyle = '#e9c7a3'; ctx.beginPath(); ctx.arc(203, 222, 13, 0, Math.PI * 2); ctx.fill();
      ctx.fillStyle = '#0d1f3c'; ctx.beginPath(); ctx.arc(201, 219, 14, Math.PI * 0.95, Math.PI * 2.05); ctx.fill();
      ctx.fillRect(208, 216, 13, 5);
      ctx.fillStyle = '#2e9bd6'; ctx.fillRect(190, 214, 8, 3);
      var a = batAngle(now);
      drawBat(a);
      ctx.strokeStyle = '#1b3768'; ctx.lineWidth = 8;
      ctx.beginPath(); ctx.moveTo(200, 244); ctx.lineTo(P.x, P.y); ctx.stroke();
      ctx.fillStyle = '#0d1f3c'; ctx.beginPath(); ctx.arc(P.x, P.y, 6, 0, Math.PI * 2); ctx.fill();
    }

    function drawBat(a) {
      ctx.save(); ctx.translate(P.x, P.y); ctx.rotate(a);
      var grad = ctx.createLinearGradient(0, -7, 0, 7);
      grad.addColorStop(0, '#f3dcb4'); grad.addColorStop(0.5, '#e2bf88'); grad.addColorStop(1, '#b98d55');
      ctx.fillStyle = grad;
      ctx.beginPath();
      ctx.moveTo(-14, -3); ctx.lineTo(55, -3.2); ctx.quadraticCurveTo(80, -7, BAT_LEN - 6, -7);
      ctx.quadraticCurveTo(BAT_LEN + 2, -7, BAT_LEN + 2, 0); ctx.quadraticCurveTo(BAT_LEN + 2, 7, BAT_LEN - 6, 7);
      ctx.quadraticCurveTo(80, 7, 55, 3.2); ctx.lineTo(-14, 3); ctx.closePath(); ctx.fill();
      ctx.fillStyle = '#0d1f3c'; ctx.fillRect(-20, -5, 7, 10);
      ctx.fillStyle = 'rgba(13,31,60,.85)'; ctx.font = '700 8px Oswald, Arial, sans-serif'; ctx.textAlign = 'left';
      ctx.fillText('ZORIAN', 96, 3);
      ctx.restore();
    }

    function drawBall(x, y, spin) {
      ctx.save(); ctx.translate(x, y); ctx.rotate(spin || 0);
      ctx.fillStyle = '#fff'; ctx.beginPath(); ctx.arc(0, 0, 7, 0, Math.PI * 2); ctx.fill();
      ctx.strokeStyle = '#d12b2b'; ctx.lineWidth = 1.2;
      ctx.beginPath(); ctx.arc(-6, 0, 5, -0.9, 0.9); ctx.stroke();
      ctx.beginPath(); ctx.arc(6, 0, 5, Math.PI - 0.9, Math.PI + 0.9); ctx.stroke();
      ctx.restore();
    }

    function ballPos(now) {
      var u = (now - g.release) / g.T;
      var x = REL.x + (CONTACT_X - REL.x) * u;
      var y = REL.y + (g.ballYEnd - REL.y) * u - Math.sin(Math.min(u, 1) * Math.PI) * 18;
      return { x: x, y: y, u: u };
    }

    function overlayText(now) {
      if (!g.result) {
        if (g.state === 'idle') {
          ctx.fillStyle = 'rgba(8,20,40,.55)'; ctx.fillRect(0, 0, W, H);
          ctx.textAlign = 'center'; ctx.fillStyle = '#fff';
          ctx.font = '700 44px "Libre Baskerville", Georgia, serif';
          ctx.fillText('Play Ball!', W / 2, H / 2 - 6);
          ctx.font = '500 15px Oswald, Arial, sans-serif'; ctx.fillStyle = '#cfe8f7';
          ctx.fillText('T A P   T O   S T A R T   •   1 0   P I T C H E S', W / 2, H / 2 + 30);
        }
        return;
      }
      var r = g.result;
      if (g.state === 'over') { ctx.fillStyle = 'rgba(8,20,40,.6)'; ctx.fillRect(0, 0, W, H); }
      var age = g.state === 'over' ? 400 : now - g.resultAt;
      var sc = Math.min(1, age / 160);
      ctx.save(); ctx.translate(W / 2, 92); ctx.scale(0.7 + 0.3 * sc, 0.7 + 0.3 * sc);
      ctx.globalAlpha = sc; ctx.textAlign = 'center';
      ctx.font = '700 46px "Libre Baskerville", Georgia, serif';
      ctx.lineWidth = 6; ctx.strokeStyle = 'rgba(8,20,40,.7)'; ctx.strokeText(r.big, 0, 0);
      ctx.fillStyle = r.color; ctx.fillText(r.big, 0, 0);
      ctx.font = '500 15px Oswald, Arial, sans-serif'; ctx.fillStyle = '#e8f3fb';
      ctx.fillText(r.sub.toUpperCase(), 0, 30);
      ctx.restore();
    }

    var last = performance.now();
    function frame(now) {
      var dt = Math.min(50, now - last); last = now;

      if (g.state === 'windup' && now - g.windupStart >= g.windupMs) {
        g.state = 'pitch'; g.release = now;
      }

      bg();
      catcher();
      pitcher(now);
      batter(now);

      if (g.state === 'pitch') {
        var b = ballPos(now);
        if (!g.judged && b.u >= 1) judge(now);
        if (g.state === 'pitch') {
          g.trail.push({ x: b.x, y: b.y }); if (g.trail.length > 8) g.trail.shift();
          if (b.x <= CATCH_X + 34) {
            if (g.swingStart !== null) setResult('STRIKE', 'Too late. Start your swing sooner!', '#ff6b6b', now);
            else setResult('STRIKE', 'Caught looking. Take a cut!', '#ff6b6b', now);
          } else {
            g.trail.forEach(function (t, i) { ctx.fillStyle = 'rgba(255,255,255,' + (i / 30) + ')'; ctx.beginPath(); ctx.arc(t.x, t.y, 5, 0, Math.PI * 2); ctx.fill(); });
            drawBall(b.x, b.y, now / 40);
          }
        }
      }

      if (g.hit) {
        var t = now - g.hit.t;
        var hx = g.hit.x + g.hit.vx * t;
        var hy = g.hit.y + g.hit.vy * t + 0.0009 * t * t;
        if (g.hit.ground && hy > 330) hy = 330 - Math.abs(Math.sin(t / 90)) * 20 * Math.max(0, 1 - t / 1400);
        if (hx > -20 && hx < W + 20 && hy > -20 && hy < H + 20) drawBall(hx, hy, t / 30);
      }

      g.particles = g.particles.filter(function (p) {
        var age = now - p.born; if (age > p.life) return false;
        ctx.globalAlpha = 1 - age / p.life; ctx.fillStyle = p.c;
        ctx.fillRect(p.x + p.vx * age, p.y + p.vy * age + 0.0002 * age * age, 4, 4);
        ctx.globalAlpha = 1; return true;
      });

      if (g.flash > 0) { ctx.fillStyle = 'rgba(255,255,255,' + (g.flash * 0.35) + ')'; ctx.fillRect(0, 0, W, H); g.flash = Math.max(0, g.flash - dt / 300); }

      overlayText(now);

      if (g.state === 'result' && now - g.resultAt > 1500) nextPitch(now);

      requestAnimationFrame(frame);
    }

    function press(e) { if (e) e.preventDefault(); swing(performance.now()); }
    cv.addEventListener('pointerdown', press);
    btn.addEventListener('click', press);
    var visible = false;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: 0.4 }).observe(cv);
    }
    window.addEventListener('keydown', function (e) {
      if (e.code !== 'Space' && e.key !== ' ') return;
      var tag = (e.target && e.target.tagName) || '';
      if (/INPUT|TEXTAREA|SELECT|BUTTON/.test(tag) || (e.target && e.target.isContentEditable)) return;
      if (!visible) return;
      e.preventDefault(); swing(performance.now());
    });

    hud();
    requestAnimationFrame(frame);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
